import {
  FileSignature,
  UserCog,
  Users as UsersIcon,
  Building2,
  KeyRound,
  Banknote,
  Gem,
  Trophy,
  Wallet,
  DollarSign,
  Send,
  History,
  MessageSquare,
  ShieldCheck,
  type LucideIcon,
} from "lucide-react";

export type SaMenuItem = { title: string; slug: string; icon: LucideIcon };
export type SaMenuGroup = { label: string; items: SaMenuItem[] };

export const SYSTEM_ADMIN_ROLE = "system_admin";

export function isSystemAdminRole(role?: string | null) {
  return role === SYSTEM_ADMIN_ROLE;
}

export const saMenuGroups: SaMenuGroup[] = [
  {
    label: "Administrativo",
    items: [
      { title: "Assinaturas", slug: "assinaturas", icon: FileSignature },
      { title: "Colaboradores", slug: "colaboradores", icon: UserCog },
      { title: "Configurar Perfil", slug: "configurar-perfil", icon: UsersIcon },
    ],
  },
  {
    label: "Gestão",
    items: [
      { title: "Centros de Treinamento", slug: "centros", icon: Building2 },
      { title: "Contas de Acesso", slug: "contas", icon: KeyRound },
      { title: "Formas de Pagamento", slug: "formas-pagamento", icon: Banknote },
    ],
  },
  {
    label: "FutBux",
    items: [
      { title: "Gerenciar Itens", slug: "itens", icon: Gem },
      { title: "Gerenciar Desafios", slug: "desafios", icon: Trophy },
    ],
  },
  {
    label: "Controle Financeiro",
    items: [
      { title: "Caixa", slug: "caixa", icon: Wallet },
      { title: "Cobrança", slug: "cobranca", icon: DollarSign },
    ],
  },
  {
    label: "Comunicação",
    items: [
      { title: "Envio de Mensagens", slug: "envio-mensagens", icon: Send },
      { title: "Histórico de Envio", slug: "historico-envios", icon: History },
      { title: "Automação e Configuração", slug: "automacao-config", icon: MessageSquare },
      { title: "E-mail Seguro", slug: "email-seguro", icon: ShieldCheck },
    ],
  },
];

export const saMenuItems = saMenuGroups.flatMap((g) => g.items);
